import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useUser } from '../contexts/UserContext';
import { useSchool } from '../contexts/SchoolContext';

const DashboardPage = () => {
  const { t } = useTranslation();
  const { user } = useUser();
  const { school } = useSchool();
  const navigate = useNavigate();
  
  // If on a subdomain, redirect to that school's admin page
  React.useEffect(() => {
    if (school) {
      navigate(`/${school.subdomain}/admin`);
    }
  }, [school, navigate]);
  
  // Redirect to SchoolSelectorDashboard if it exists
  React.useEffect(() => {
    navigate('/dashboard');
  }, [navigate]);
  
  return (
    <div className="min-h-screen bg-gray-50 p-8">
      <h1 className="text-2xl font-bold mb-4">{t('dashboard.title', 'Dashboard')}</h1>
      <p>{t('dashboard.loading', 'Loading dashboard...')}</p>
    </div>
  );
};

export default DashboardPage; 